/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetCompanySettingsResponseData,
  GetCompanySettingsResponseDataFromJSON,
  GetCompanySettingsResponseDataFromJSONTyped,
  GetCompanySettingsResponseDataToJSON
} from './GetCompanySettingsResponseData'

/**
 *
 * @export
 * @interface UpdateSortCompanySettingsResponse
 */
export interface UpdateSortCompanySettingsResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateSortCompanySettingsResponse
   */
  status?: number
  /**
   *
   * @type {GetCompanySettingsResponseData}
   * @memberof UpdateSortCompanySettingsResponse
   */
  data?: GetCompanySettingsResponseData
}

export function UpdateSortCompanySettingsResponseFromJSON(json: any): UpdateSortCompanySettingsResponse {
  return UpdateSortCompanySettingsResponseFromJSONTyped(json, false)
}

export function UpdateSortCompanySettingsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateSortCompanySettingsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetCompanySettingsResponseDataFromJSON(json['data'])
  }
}

export function UpdateSortCompanySettingsResponseToJSON(value?: UpdateSortCompanySettingsResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetCompanySettingsResponseDataToJSON(value.data)
  }
}
